module.exports = __webpack_public_path__ + "img/sancionado.8b474c6f.png";